<template>
  <div class="card mt-3">
    <header v-for="info in member" :key="info.tag" class="card-header has-background-info-dark">
      <p class="card-header-title has-text-info-light">
        {{ info.name }}
      </p>
      <router-link :to="'/member/' + info.tag.substring(1)">
        <button class="button is-info is-light is-pulled-right mt-1 mr-4">
          ℹ Info
        </button>
      </router-link>
    </header>
    <div class="card-content">
      <small v-for="info in member" :key="info.tag">
        Osvježeno: {{ info.updated | moment('calendar') }} ({{
          info.updated | moment('from', 'now')
        }})
      </small>
      <MemberTrophies />
      <div class="columns">
        <div class="column"></div>
        <div class="column"></div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberTrophies from '@/components/memberInfo/charts/MemberTrophies.vue';

import { ref } from '@vue/composition-api';
import { useRouter } from '@u3u/vue-hooks';

export default {
  components: {
    MemberTrophies,
  },
  setup() {
    const { route } = useRouter();
    const apiHost = process.env.VUE_APP_API_HOST;
    const infoURL = '/player/info/';
    const { id } = route.value.params;

    const member = ref([]);

    const API_URL = apiHost;

    async function getMember() {
      const response = await fetch(API_URL + infoURL + id);
      const json = await response.json();
      member.value = json;
    }

    getMember();

    return {
      member,
    };
  },
};
</script>
